//No CiCa available for travel so flag should be turned false only if CiCa page is built for travel
const DeclarationConfig = {
    travel: true, 
    car: false,
    van: false,
    home: false,
    device: false
}
export default DeclarationConfig